// extracted by css-extract-rspack-plugin
export default {"MPTable":"MPTable-MZHda6","mpTable":"MPTable-MZHda6"};